<template>
    <div> 
        <div v-if="is_super_admin">
        <div style="padding: 0px 16px;">
            <el-button plain type="primary" @click="addPoints" size="small" icon="el-icon-plus">新增会员积分规则</el-button>
        </div>

        <div style="padding: 10px 16px;">
            <el-table
                :data="lVipPointsList"
                style="width: 100%;border-color:'#606266'"
                :default-sort = "{prop: 'date', order: 'descending'}"
                :header-cell-style="{background:'#f8f8f8', fontFamily:'Helvetica',fontSize:'14px'}"
                :cell-style="{color: '#666',fontSize:'14px'}"
                border
            >
                <el-table-column
                    fixed
                    align="center"
                    prop="vip_points_id"
                    label="会员积分配置ID"
                    sortable
                    >
                </el-table-column>

                <el-table-column
                    fixed
                    align="center"
                    prop="vip_points"
                    label="所需积分"
                    sortable
                    >
                </el-table-column>

                <el-table-column
                    fixed
                    align="center"
                    prop="points_coupon_valid_days"
                    label="有效天数"
                    sortable
                    >
                </el-table-column>

                <el-table-column
                    fixed
                    align="center"
                    prop="points_coupon_type_id"
                    label="优惠券类型ID"
                    sortable
                    >
                </el-table-column>

                <el-table-column
                    fixed
                    align="center"
                    prop="points_coupon_info.coupon_name"
                    label="优惠券名称"
                    sortable
                    >
                </el-table-column>

                <el-table-column
                    prop="points_coupon_info.coupon_mode"
                    label="抵扣方式"
                    align="center"
                >
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.points_coupon_info.coupon_mode == 1">现金抵扣</el-tag>
                        <el-tag v-else>折扣方式</el-tag>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="points_coupon_info.coupon_amount"
                    label="抵扣金额"
                    align="center"
                >
                </el-table-column>

                <el-table-column
                    prop="points_coupon_info.coupon_discount"
                    label="折扣率"
                    align="center"
                >
                </el-table-column>

                <el-table-column
                    align="center"
                    label="操作"
                    width="150px"
                >
                    <template slot-scope="scope">
                        <el-button round icon="el-icon-delete" type="danger" size="small" @click="deleteFunc(scope.row)">删除</el-button>
                    </template>
                </el-table-column>


            </el-table>
        </div>
        

        <el-dialog :visible.sync="bShowDialog" :fullscreen="bShowFullscreen" :before-close="this.$dialog_close" :show-close="false">
            <div slot="title" class="dialog-title">
                <span style="font-size: 18px; line-height: 24px; color: #303133;">{{ sDialogName }}</span>
                <el-button icon="el-icon-close" class='dialog-title-button' @click="bShowDialog = false"></el-button>
                <el-button icon="el-icon-full-screen" class='dialog-title-button' @click="bShowFullscreen = !bShowFullscreen"></el-button>
            </div>

            <el-form :model="dFromData" ref="dFromData" labeel-width="100px" @class="demo-dFromData">
                <el-row :gutter="24">
                    <el-col :span="8">
                        <el-form-item label="所需积分" prop="vip_points">
                            <el-input-number v-model="dFromData.vip_points" :min="0" :step="10" label="最低充值金额" ></el-input-number>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="有效天数" prop="points_coupon_valid_days">
                            <el-input-number v-model="dFromData.points_coupon_valid_days" :min="0" :step="10" label="最低充值金额" ></el-input-number>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="优惠券" prop="points_coupon_type_id">
                            <el-select v-model="dFromData.points_coupon_type_id" clearable  placeholder="请选择优惠券">
                                <el-option
                                    v-for="item in lCouponTypeList"
                                    :key="item.coupon_type_id"
                                    :value="item.coupon_type_id"
                                    :label="item.coupon_name"
                                > 
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="cancelFunc">取 消</el-button>
                <el-button type="primary" @click="defineFunc">确 定</el-button>
            </div>
        </el-dialog>
        </div>

        <div v-else>
            <div style="text-align: center;">
                <div style="margin-top: 0px;">
                <img src="../../assets/permission_denied.png">
                <div style="margin-top: 20px;">
                    <span style="font-size: 18px; line-height: 24px; color: #303133;">您没有权限访问该页面</span>
                </div>
                </div>
            </div>
        </div>

    </div>
    
</template>

<script>
export default {
    name: "VipPointsSystem",
    data(){
        return {
            sDialogName: '',
            bShowDialog: false,
            sBtnName: '',
            bShowFullscreen: false,
            bRequestType: true,
            // 优惠券类型列表
            lCouponTypeList: [],

            dFromData: {},
            // 积分配置列表
            lVipPointsList: [],

            is_super_admin: false,
        }
    },

    mounted(){
        // 判断当前用户是否是超级管理员, 如果不是超级管理员, 页面提示无权限操作
        let isSuperAdmin = window.sessionStorage.getItem("is_super_admin")
        if (isSuperAdmin == "false") {
            this.is_super_admin = false
            return
        } else {
        this.is_super_admin = true
        }
        this.getVipPointsConfig();

    },

    methods: {
        // 获取积分配置
        async getVipPointsConfig(){
            let url = '/api/vip_points/'
            let res = await this.$axios.get(url)
            // console.log(res)
            this.lVipPointsList = res.data
            console.log(this.lVipPointsList )
        },

        // 新增积分配置
        addPoints(){
            this.getAllCouponType()

            this.sDialogName = '新增积分配置'
            this.bShowDialog = true
            this.sBtnName = '确定'
            this.iDiaglogType = 1
            this.dFromData = {}

            
        },

        // 请求所有的优惠券类型
        async getAllCouponType(){
            let url = '/api/coupon_type/'
            let res = await this.$axios.get(url)
            console.log(res)
            this.lCouponTypeList = res.data
            console.log(this.lCouponTypeList)
        },

        // 取消事件
        cancelFunc(){
            this.bShowDialog = false
        },

        // 确定事件
        async defineFunc(){
            let url = '/api/vip_points/'
            let res = await this.$axios.post(url, this.dFromData)
            // console.log(res)
            this.bShowDialog = false
            this.getVipPointsConfig()
        },

        // 删除积分配置
        deleteFunc(row){
            var _this = this
            this.$confirm('此操作将永久删除该消息', '删除消息警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                _this.$axios.delete('/api/vip_points/' + row.vip_points_id + '/').then(
                function(res){_this.$message({type: 'success', message: '删除成功!'});
                _this.getVipPointsConfig()})
            }).catch(() => {
                _this.$message({type: 'info',message: '已取消删除'});          
            });
        },
    },
}
</script>